import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import emptyStateImg from '../../../../assets/images/analyticsEmptyState.png';

/*
 * Props.
 */

interface EmptyStateProps {
  isCompact?: boolean;
}

/*
 * Styles.
 */

const StyledEmptyStateWrapperDiv = styled.div<{$isCompact: boolean}>`
  display: flex;
  flex-direction: ${(p) => (p.$isCompact ? 'row' : 'column')};
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin: ${(p) => (p.$isCompact ? '17px 0 0 0' : '50px 0 34px 0')};
`;

const StyledEmptyStateMessageDiv = styled.div<{$isCompact: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: ${(p) => (p.$isCompact ? 'flex-start' : 'center')};
`;

const StyledEmptyStateTitleDiv = styled.div`
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade80};
  line-height: 28px;
`;

const StyledEmptyStateSubtitleDiv = styled.div`
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.greys.shade60};
  line-height: 20px;
`;

/*
 * Component.
 */

export const ReportSectionEmptyState: FC<EmptyStateProps> = ({isCompact = false}) => (
  <StyledEmptyStateWrapperDiv $isCompact={isCompact}>
    <img src={emptyStateImg} alt="no data" height={66} />
    <StyledEmptyStateMessageDiv $isCompact={isCompact}>
      <StyledEmptyStateTitleDiv>
        <Trans id="analytics-empty-state-title">No data</Trans>
      </StyledEmptyStateTitleDiv>
      <StyledEmptyStateSubtitleDiv>
        <Trans id="analytics-empty-state-subtitle">No matching data for the selected filters.</Trans>
      </StyledEmptyStateSubtitleDiv>
    </StyledEmptyStateMessageDiv>
  </StyledEmptyStateWrapperDiv>
);
